'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clear2 = require('./internal/_clear');

var _clear3 = _interopRequireDefault(_clear2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns an empty copy of `subject`.
 *
 * @example
 * clear([1, 2, 3]) // returns []
 * clear(List.of(1, 2, 3)) // returns List []
 * clear({one: 1, two: 2, three: 3}) // returns {}
 *
 * @param {Array|Collection|Object} subject
 * @return {Array|Collection|Object}
 */
exports.default = _clear3.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/clear.js
// module id = 172
// module chunks = 0 1